module.exports = __webpack_public_path__ + "static/media/video.3bf817df.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/CCIWA/video.jpg
// module id = 216
// module chunks = 0